let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1BR4N")).then(() => parcelRequire('2WgyJ'));